// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep div.image {
  border: 1px solid lightgray;
  border-radius: 8px;
}
::ng-deep div.news-list-item {
  position: relative;
  box-shadow: var(--shadow-4);
  border: 1px solid var(--shadow-4);
  border-radius: 8px;
  /*background-image: url('/assets/images/advertisement-one.png');*/
  background-repeat: no-repeat;
  background-position: right;
  height: 145px;
  padding-top: 0.8rem;
  padding-left: 1.4rem;
  overflow: hidden;
}
::ng-deep div.news-list-item .title {
  max-width: max(70%, 300px);
  text-transform: uppercase;
}
::ng-deep div.news-list-item .title a {
  color: var(--accent);
  font-weight: 700;
}
::ng-deep div.news-list-item .title a:hover {
  color: #f28c38;
}
::ng-deep div.news-list-item .title a.smaller {
  font-size: 0.85em !important;
}
::ng-deep div.news-list-item .sub-title {
  color: var(--primary);
  font-size: 0.67em !important;
}
::ng-deep div.news-list-item button {
  position: absolute;
  bottom: 1rem;
  left: 1rem;
}
::ng-deep div.news-list-item .news-image {
  background-image: url("/assets/images/news/trending/2024-04-15/1.jpg");
  position: absolute;
  bottom: calc(-1rem - 96px);
  right: calc(-1rem - 97px);
  width: 280px; /* Adjust based on your image size */
  height: 286px;
  object-fit: cover; /* Ensure the image scales properly */
  clip-path: ellipse(50% 40% at 50% 50%);
  z-index: 0; /* Behind the button */
}
::ng-deep div.news-list-item .meta-details {
  display: inline-block;
  padding: 6px 15px 6px 7px;
  border-radius: 30px;
  background-color: var(--primary);
  position: absolute;
  bottom: 1rem;
}
::ng-deep div.news-list-item .meta-details img {
  height: 28px;
  width: 28px;
  border-radius: 50%;
  display: inline-block;
}
::ng-deep div.news-list-item .meta-details span {
  color: var(--white);
  display: inline-block;
  margin-left: 10px;
  font-size: 10px !important;
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/app/news/list/news-list.component.scss"],"names":[],"mappings":"AAEE;EACC,2BAAA;EACA,kBAAA;AADH;AAIE;EACC,kBAAA;EACA,2BAAA;EACA,iCAAA;EACA,kBAAA;EACA,iEAAA;EACA,4BAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;AAFH;AAIG;EACC,0BAAA;EACA,yBAAA;AAFJ;AAII;EACC,oBAAA;EACA,gBAAA;AAFL;AAIK;EACC,cAAA;AAFN;AAKK;EACC,4BAAA;AAHN;AAQG;EACC,qBAAA;EACA,4BAAA;AANJ;AASG;EACC,kBAAA;EACA,YAAA;EACA,UAAA;AAPJ;AAUG;EACC,sEAAA;EACA,kBAAA;EACA,0BAAA;EACA,yBAAA;EACA,YAAA,EAAA,oCAAA;EACA,aAAA;EACA,iBAAA,EAAA,qCAAA;EACA,sCAAA;EACA,UAAA,EAAA,sBAAA;AARJ;AAWG;EACC,qBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gCAAA;EACA,kBAAA;EACA,YAAA;AATJ;AAWI;EACC,YAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;AATL;AAYI;EACC,mBAAA;EACA,qBAAA;EACA,iBAAA;EACA,0BAAA;EACA,gBAAA;AAVL","sourcesContent":["::ng-deep {\n\tdiv {\n\t\t&.image {\n\t\t\tborder: 1px solid lightgray;\n\t\t\tborder-radius: 8px;\n\t\t}\n\n\t\t&.news-list-item {\n\t\t\tposition: relative;\n\t\t\tbox-shadow: var(--shadow-4);\n\t\t\tborder: 1px solid var(--shadow-4);\n\t\t\tborder-radius: 8px;\n\t\t\t/*background-image: url('/assets/images/advertisement-one.png');*/\n\t\t\tbackground-repeat: no-repeat;\n\t\t\tbackground-position: right;\n\t\t\theight: 145px;\n\t\t\tpadding-top: 0.8rem;\n\t\t\tpadding-left: 1.4rem;\n\t\t\toverflow: hidden;\n\n\t\t\t.title {\n\t\t\t\tmax-width: max(70%, 300px);\n\t\t\t\ttext-transform: uppercase;\n\n\t\t\t\ta {\n\t\t\t\t\tcolor: var(--accent);\n\t\t\t\t\tfont-weight: 700;\n\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\tcolor: #f28c38;\n\t\t\t\t\t}\n\n\t\t\t\t\t&.smaller {\n\t\t\t\t\t\tfont-size: .85em !important;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.sub-title {\n\t\t\t\tcolor: var(--primary);\n\t\t\t\tfont-size: .67em !important;\n\t\t\t}\n\n\t\t\tbutton {\n\t\t\t\tposition: absolute;\n\t\t\t\tbottom: 1rem;\n\t\t\t\tleft: 1rem;\n\t\t\t}\n\n\t\t\t.news-image {\n\t\t\t\tbackground-image: url('/assets/images/news/trending/2024-04-15/1.jpg');\n\t\t\t\tposition: absolute;\n\t\t\t\tbottom: calc(-1rem - 96px);\n\t\t\t\tright: calc(-1rem - 97px);\n\t\t\t\twidth: 280px; /* Adjust based on your image size */\n\t\t\t\theight: 286px;\n\t\t\t\tobject-fit: cover; /* Ensure the image scales properly */\n\t\t\t\tclip-path: ellipse(50% 40% at 50% 50%);\n\t\t\t\tz-index: 0; /* Behind the button */\n\t\t\t}\n\n\t\t\t.meta-details {\n\t\t\t\tdisplay: inline-block;\n\t\t\t\tpadding: 6px 15px 6px 7px;\n\t\t\t\tborder-radius: 30px;\n\t\t\t\tbackground-color: var(--primary);\n\t\t\t\tposition: absolute;\n\t\t\t\tbottom: 1rem;\n\n\t\t\t\timg {\n\t\t\t\t\theight: 28px;\n\t\t\t\t\twidth: 28px;\n\t\t\t\t\tborder-radius: 50%;\n\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t}\n\n\t\t\t\tspan {\n\t\t\t\t\tcolor: var(--white);\n\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\tmargin-left: 10px;\n\t\t\t\t\tfont-size: 10px !important;\n\t\t\t\t\tfont-weight: 500;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
